export default __webpack_public_path__ + "static/media/close_meeting_detail.1999b733.svg";